// All styles live inside the Shadow DOM, so they can't leak to or from the host
// page. Namespaced class names add a second layer of safety.
export const STYLES = `
:host { all: initial; --fp-accent: #4f46e5; --fp-accent-dark: #4338ca; }
* { box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }

.fp-markers { position: absolute; top: 0; left: 0; width: 100%; height: 0; pointer-events: none; z-index: 2147483000; }

.fp-marker {
  position: absolute; width: 28px; height: 28px; margin: -28px 0 0 -2px;
  background: var(--fp-accent); color: #fff; border: 2px solid #fff; border-radius: 50% 50% 50% 0;
  transform: rotate(-45deg); cursor: pointer; pointer-events: auto;
  box-shadow: 0 2px 8px rgba(0,0,0,.3); display: flex; align-items: center; justify-content: center;
  transition: transform .1s ease;
}
.fp-marker:hover { transform: rotate(-45deg) scale(1.12); }
.fp-marker > span { transform: rotate(45deg); font-size: 12px; font-weight: 700; }
.fp-marker[data-status="resolved"], .fp-marker[data-status="closed"] { background: #16a34a; }
.fp-marker[data-status="in_progress"] { background: #d97706; }

.fp-toolbar {
  position: fixed; right: 20px; bottom: 20px; z-index: 2147483600;
  display: flex; gap: 8px; align-items: center;
}
.fp-toolbar.fp-left { right: auto; left: 20px; }
.fp-badge {
  font-size: 10px; color: #6b7280; background: rgba(255,255,255,.9);
  padding: 3px 8px; border-radius: 999px; box-shadow: 0 1px 4px rgba(0,0,0,.15);
}
.fp-btn {
  border: 0; border-radius: 999px; padding: 12px 18px; font-size: 14px; font-weight: 600;
  background: var(--fp-accent); color: #fff; cursor: pointer; box-shadow: 0 4px 14px rgba(79,70,229,.4);
}
.fp-btn:hover { background: var(--fp-accent-dark); }
.fp-btn.fp-active { background: #dc2626; box-shadow: 0 4px 14px rgba(220,38,38,.4); }
.fp-btn-icon { padding: 12px; width: 46px; height: 46px; }

.fp-capture {
  position: fixed; inset: 0; z-index: 2147483400; cursor: crosshair;
  background: rgba(79,70,229,.06);
}
.fp-region-capture {
  position: fixed; inset: 0; z-index: 2147483450; cursor: crosshair;
  background: rgba(17,24,39,.25);
}
.fp-region-box {
  position: fixed; border: 2px solid var(--fp-accent); background: rgba(79,70,229,.12);
  box-shadow: 0 0 0 9999px rgba(17,24,39,.001); pointer-events: none;
}
.fp-attachments { display: flex; flex-wrap: wrap; gap: 8px; margin: 4px 0 8px; }
.fp-thumb { position: relative; width: 54px; height: 54px; border-radius: 6px; overflow: hidden; border: 1px solid #d1d5db; }
.fp-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
.fp-thumb-remove {
  position: absolute; top: -6px; right: -6px; width: 18px; height: 18px; border-radius: 50%;
  background: #dc2626; color: #fff; border: 0; font-size: 11px; line-height: 18px; cursor: pointer; padding: 0;
}
.fp-attach-actions { display: flex; gap: 8px; margin-bottom: 8px; }
.fp-attach-btn {
  border: 1px solid #d1d5db; background: #fff; border-radius: 8px; padding: 6px 10px;
  font-size: 12px; cursor: pointer; color: #374151;
}
.fp-attach-btn:hover { background: #f3f4f6; }
.fp-hint {
  position: fixed; top: 16px; left: 50%; transform: translateX(-50%); z-index: 2147483500;
  background: #111827; color: #fff; padding: 8px 16px; border-radius: 8px; font-size: 13px;
  box-shadow: 0 4px 14px rgba(0,0,0,.3);
}

.fp-panel {
  position: fixed; right: 20px; bottom: 80px; width: 340px; max-width: calc(100vw - 40px);
  max-height: 70vh; z-index: 2147483600; background: #fff; border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0,0,0,.25); display: flex; flex-direction: column; overflow: hidden;
}
.fp-panel-head { padding: 14px 16px; border-bottom: 1px solid #eee; display: flex; justify-content: space-between; align-items: center; }
.fp-panel-title { font-size: 14px; font-weight: 700; color: #111827; }
.fp-close { border: 0; background: none; font-size: 20px; line-height: 1; cursor: pointer; color: #6b7280; }
.fp-thread { padding: 12px 16px; overflow-y: auto; flex: 1; }
.fp-comment { margin-bottom: 12px; }
.fp-comment-meta { font-size: 11px; color: #6b7280; margin-bottom: 2px; }
.fp-comment-meta .fp-team { color: var(--fp-accent); font-weight: 700; }
.fp-comment-body { font-size: 13px; color: #111827; white-space: pre-wrap; word-break: break-word; }
.fp-empty { font-size: 13px; color: #6b7280; }

.fp-form { padding: 12px 16px; border-top: 1px solid #eee; }
.fp-input, .fp-textarea {
  width: 100%; border: 1px solid #d1d5db; border-radius: 8px; padding: 8px 10px; font-size: 13px; margin-bottom: 8px;
}
.fp-textarea { min-height: 64px; resize: vertical; }
.fp-form-actions { display: flex; justify-content: flex-end; gap: 8px; }
.fp-link { background: none; border: 0; color: #6b7280; cursor: pointer; font-size: 13px; }
.fp-toast {
  position: fixed; bottom: 80px; left: 50%; transform: translateX(-50%); z-index: 2147483600;
  background: #111827; color: #fff; padding: 10px 16px; border-radius: 8px; font-size: 13px;
}
`;
